import { render } from "./SpiderModelComputing.vue?vue&type=template&id=20618ea9&scoped=true"
import script from "./SpiderModelComputing.vue?vue&type=script&lang=js"
export * from "./SpiderModelComputing.vue?vue&type=script&lang=js"

import "./SpiderModelComputing.vue?vue&type=style&index=0&id=20618ea9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20618ea9"]])

export default __exports__